import { render, staticRenderFns } from "./DownloadDesk.vue?vue&type=template&id=9beecf4e&scoped=true"
import script from "./DownloadDesk.vue?vue&type=script&lang=js"
export * from "./DownloadDesk.vue?vue&type=script&lang=js"
import style0 from "./DownloadDesk.vue?vue&type=style&index=0&id=9beecf4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9beecf4e",
  null
  
)

export default component.exports